<p-table [columns]="tableCols" #dt [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)">
  <ng-template pTemplate="caption">
    {{title}}
    <div class="float-right ui-helper-clearfix" >
        <em class="fa fa-search" style="margin:4px 4px 0 0"></em>
        <input type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" class="bg-white p-0">
    </div>
</ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <ng-container *ngFor="let col of columns">
        <th id="{{col.field+'Column'}}" *ngIf="col.field!=isLab && col.field!=isDefaultTemplate && col.field!=isProcessStepPrinter && col.field!=isProcessList && col.field != isqcEvaluationStep && col.field != 'nextStepForQCNotCompleted' && col.field != 'nextStepForQCFailed'"
          [pSortableColumn]="col.field==isLab ? col.sort:col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field==isLab ? col.sort:col.field"></p-sortIcon>
        </th>
        <th id="{{col.field+'Column'}}" *ngIf="col.field ==isqcEvaluationStep"
          [pSortableColumn]="col.field">
          Steps with QC Data
          <p-sortIcon [field]=col.field></p-sortIcon>
        </th>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td *ngIf="col.field==isProcessStepName ||col.field == 'storagePlatePrefix' ||col.field == isQcType ||col.field==isNextStep || col.field==isPlatePrefix || col.field==isSourcePlatePrefixes
            || col.field==isProcess || col.field==isStation || col.field==isWorkfileDef || col.field==isStepDisplayName || col.field==isSortingName || col.field==isSpecialHandling || col.field==isqcEvaluationStep || col.field == 'nextStepForQCPassed'"  class="wrapword overflowBreak">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == isActive">
          <p-checkbox id="checkBox" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field == isProcessStepMachineType">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align:left">
      <button type="button" pButton class="h-2rem" icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{popupTitle}} Details" position="top" [(visible)]="displayMasterListDialog"  showEffect="fade" [modal]="true"
    [style]="{'width':'1000px'}" [baseZIndex]="1000">
  <div *ngIf="masterList">
    <div *ngFor="let col of tableCols">
      <div class="form-group m-2">
        <div *ngIf="col.field!=isDefaultLanguage">
            <label style="margin-left:4px ;">{{col.header}}</label>
            <label style="margin-left: 35%;" *ngIf="col.field == 'nextStepForQCPassed'">Problem Category for QC passed</label>
            <label style="margin-left: 37%;" *ngIf="col.field == 'nextStepForQCFailed'">Problem Category for QC failed</label>
        </div>
        <div *ngIf="col.field == isProcessStepName">
          <p-dropdown [options]="processStepOptions" [(ngModel)]="selectedProcessStep" filter="true" optionLabel="label"
                      optionValue="value" filterBy="label" [style]="{'width':'100%' , 'margin-left' : '4px' }"
            placeholder="Select a process step" (onShow)="dropdownOpen = true" (onHide)="dropdownOpen = false"
            [showClear]="true" [disabled]="masterList?._id"></p-dropdown>
         </div>
         <div *ngIf="col.field == isStepDisplayName">
          <input pInputText class="form-control" style="margin-left:4px ;" [(ngModel)]="masterList[col.field]" (change)="masterList[col.field]=masterList[col.field].trim()"
             oninput="this.value = this.value.replace(/[^0-9a-zA-Z_]/, '')" (blur)="getListOfWorkfileDefinition()" [disabled]="masterList?._id">
         </div>
         <div *ngIf="col.field == isSortingName">
          <input pInputText class="form-control" style="margin-left:4px ;" [(ngModel)]="masterList[col.field]" (change)="masterList[col.field]=masterList[col.field].trim()"
              oninput="this.value = this.value.replace(/[^0-9a-zA-Z_]/, '')">
         </div>
        <div *ngIf="col.field == isLab">
          <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" filter="true"
                     filterBy="name" placeholder="Select a Lab"
            optionLabel="name" [showClear]="true" [style]="{'width':'100%' , 'margin-left' : '4px'}" (onChange)="getDropDetailsBySelectedLab()"></p-dropdown>
        </div>

        <div *ngIf="col.field == isProcessStepMachineType">
          <p-dropdown [options]="machineTypesOptions" [(ngModel)]="selectedMachineType" filter="true"
                     filterBy="name" placeholder="Select a Machine Type"
              [style]="{'width':'100%' , 'margin-left' : '4px'}" optionLabel="name" [showClear]="true"></p-dropdown>
        </div>

        <div *ngIf="col.field == isProcessStepPrinter">
          <p-dropdown [options]="printerOptions" [(ngModel)]="selectedPrinter" filter="true"
                     filterBy="name" [style]="{'width':'100%' , 'margin-left' : '4px'}" optionLabel="name"
              placeholder="Select a printer" [showClear]="true"></p-dropdown>
        </div>

        <div *ngIf="col.field == isDefaultTemplate">
          <p-dropdown [options]="templateOptions" [(ngModel)]="selectedTemplate" filter="true"
                     filterBy="templateName" [style]="{'width':'100%' , 'margin-left' : '4px'}" optionLabel="templateName"
                placeholder="Select a template" [showClear]="true"></p-dropdown>
        </div>

        <div *ngIf="col.field == isNextStep">
          <p-dropdown [options]="processStepOptions" [(ngModel)]="nextProcessStep" filter="true" optionLabel="label" optionValue="value"
                     filterBy="label" [style]="{'width':'100%' , 'margin-left' : '4px'}"
            placeholder="Select a next step" [showClear]="true"></p-dropdown>
        </div>

        <div *ngIf="col.field == isProcessList ">
            <p-checkbox class="leftAlignment" id="processList" [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>

        <div *ngIf="col.field == isWorkfileDef" id="filterLabel">
          <p-multiSelect [options]="workfileDefOptions"  [(ngModel)]="selectedWorkfileDef"
            id="multiselectStatuses" optionLabel="label" optionValue="value" [style]="{'width':'346%' ,  'height': '38px'}">
            <ng-template let-item pTemplate="selectedItem">
              <span style="vertical-align:middle">{{item.label}}</span>
            </ng-template>
            <ng-template let-status pTemplate="item">
              {{status.label}}
            </ng-template>
          </p-multiSelect>
        </div>

        <div *ngIf="col.field == isQcType">
          <p-dropdown [options]="qcTypeOptions" [(ngModel)]="selectedQcType" [style]="{'width':'100%' , 'margin-left' : '4px'}"
              placeholder="Select Qc Type" [showClear]="true"></p-dropdown>
        </div>

        <div *ngIf="col.field == isSourcePlatePrefixes">
          <input pInputText class="form-control" [(ngModel)]="sourcePlatePrefixes" class="fieldWidth leftAlignment"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z_]/, '')">
        </div>

        <div *ngIf="col.field == isPlatePrefix">
            <input pInputText class="form-control" [(ngModel)]="platePrefixes" class="fieldWidth leftAlignment">
        </div>

        <div *ngIf="col.field == 'storagePlatePrefix'">
          <input pInputText class="form-control" [(ngModel)]="storagePlatePrefix" class="fieldWidth leftAlignment">
      </div>

        <div *ngIf="col.field == isProcess">
          <p-dropdown [options]="processOptions" [(ngModel)]="selectedProcess" filter="true"
                     filterBy="name" [style]="{'width':'100%' , 'margin-left' : '4px'}" optionLabel="name"
              placeholder="Select a Process" [showClear]="true"></p-dropdown>
        </div>

        <div *ngIf="col.field == isStation">
          <p-dropdown [options]="stationOptions" [(ngModel)]="selectedStation" filter="true"
                     filterBy="name" [style]="{'width':'100%' , 'margin-left' : '4px'}" optionLabel="name"
          placeholder="Select a Station" [showClear]="true"></p-dropdown>
        </div>

        <div *ngIf="col.field == isSpecialHandling" id="filterLabel">
          <p-multiSelect [options]="specialHandlingOptions"  [(ngModel)]="selectedSpecialHandlers"
            id="multiselectStatuses" optionLabel="label" optionValue="value" [style]="{'width':'346%' ,  'height': '38px'}">
            <ng-template let-item pTemplate="selectedItem">
              <span style="vertical-align:middle">{{item.label}}</span>
            </ng-template>
            <ng-template let-status pTemplate="item">
              {{status.label}}
            </ng-template>
          </p-multiSelect>
        </div>

        <div *ngIf="col.field == isqcEvaluationStep" id="filterLabel">
          <p-multiSelect [options]="processStepOptions"  [(ngModel)]="selectedQCEvaluationStep"
            id="multiselectStatuses" optionLabel="label" optionValue="value" [style]="{'width':'346%' ,  'height': '38px'}">
            <ng-template let-item pTemplate="selectedItem">
              <span style="vertical-align:middle">{{item.label}}</span>
            </ng-template>
            <ng-template let-status pTemplate="item">
              {{status.label}}
            </ng-template>
          </p-multiSelect>
        </div>
        <div *ngIf="col.field == 'nextStepForQCNotCompleted'">
          <p-dropdown [options]="processStepOptions" [(ngModel)]="masterList[col.field]" filter="true" optionLabel="label"
                      optionValue="value" filterBy="label" [style]="{'width':'100%' , 'margin-left' : '4px'}"
          placeholder="Select a Next Step" [showClear]="true"></p-dropdown>
        </div>
        <div *ngIf="col.field == 'nextStepForQCPassed'" class="qcOptions">
            <div class="halfDiv">
              <p-multiSelect [options]="processStepOptions"  [(ngModel)]="masterList[col.field]"
                id="multiselectStatuses" optionLabel="label" optionValue="value" [style]="{'width':'100%' ,  'height': '38px'}">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
            <div class="halfDiv">
              <p-dropdown [options]="problemCategoryOptions" [disabled]="!masterList.nextStepForQCPassed || masterList.nextStepForQCPassed == 0" [(ngModel)]="selectedProblemCategoryForQCPassed" [style]="{'width':'60%' , 'margin-left' : '10%'}" (onChange)="masterList['problemCategoryForQCPassed']=$event.value"
              placeholder="Select a Problem Category" [showClear]="true"></p-dropdown>
            </div>
        </div>

        <div *ngIf="col.field == 'nextStepForQCFailed'" class="qcOptions">
          <div class="halfDiv">
              <p-multiSelect [options]="processStepOptions"  [(ngModel)]="masterList[col.field]"
                id="multiselectStatuses" optionLabel="label" optionValue="value" [style]="{'width':'100%' ,  'height': '38px'}">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
            <div class="halfDiv">
              <p-dropdown [options]="problemCategoryOptions" [disabled]="!masterList.nextStepForQCFailed || masterList.nextStepForQCFailed == 0" [(ngModel)]="selectedProblemCategoryForQCFailed" [style]="{'width':'60%' , 'margin-left' : '10%'}" (onChange)="masterList['problemCategoryForQCFailed']=$event.value"
              placeholder="Select a Problem Category" [showClear]="true"></p-dropdown>
            </div>
        </div>
        <div *ngIf="col.field == isActive">
          <p-checkbox class="leftAlignment" id="active" [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>

      </div>
    </div>
    <div class="form-group">
      <label>{{formatHeader}}</label>
    </div>
  </div>

  <div class="ui-dialog-buttonpane ui-helper-clearfix flex justify-content-end">
    <button type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" (click)="saveMasterList()" class="h-2rem"
      label="Save"></button>
  </div>

</p-dialog>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
